import { HIDE_TOOLTIP, RESET_STATE } from '../../../reducer';
export const EXPAND_ROW = 'MerchantTransactions/EXPAND_ROW';
export const LOAD_TRANSACTIONS = 'MerchantTransactions/LOAD_TRANSACTIONS';
export const SET_TRANSACTION_DATA = 'MerchantTransactions/SET_TRANSACTION_DATA';
export const LOAD_TRANSACTION_FAILURE =
  'MerchantTransactions/LOAD_TRANSACTION_FAILURE';
export const ORDER_BY = 'MerchantTransacions/ORDER_BY';
export const CHANGE_SORT_ORDER = 'MerchantTransactions/CHANGE_SORT_ORDER';
export const DOWNLOAD_CSV = 'MerchantTransactions/DOWNLOAD_CSV';
export const SHOW_TOOLTIP = 'MerchantTransactions/SHOW_TOOLTIP';

export const expandRow = id => ({
  type: EXPAND_ROW,
  id
});

export const loadTransactions = params => ({
  type: LOAD_TRANSACTIONS,
  params
});

export const setTransactionData = payload => ({
  type: SET_TRANSACTION_DATA,
  payload
});

export const loadTransactionFailure = error => ({
  type: LOAD_TRANSACTION_FAILURE,
  error
});

export const downloadCsv = () => ({
  type: DOWNLOAD_CSV
});

export const changeSortOrder = orderBy => ({
  type: CHANGE_SORT_ORDER,
  orderBy
});

export const showTooltip = tooltip => ({
  type: SHOW_TOOLTIP,
  tooltip
});

const initialState = {
  expandedRow: undefined,
  transactions: [],
  transactionsLoading: true,
  transactionsFailed: false,
  currentPage: 1,
  previouslyVisited: [1],
  loading: true,
  orderBy: 'commissions.created_at',
  orderDirection: 'desc',
  activeTooltip: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case EXPAND_ROW:
      return {
        ...state,
        expandedRow: action.id === state.expandedRow ? undefined : action.id
      };
    case SET_TRANSACTION_DATA:
      return {
        ...state,
        transactions: action.payload.commissions,
        // paginatorTotal: Math.ceil(action.payload.commissions_count / 25),
        transactionsLoading: false
      };
    case LOAD_TRANSACTION_FAILURE:
      return {
        ...state,
        transactionsFailed: true,
        message: action.error
      };
    case CHANGE_SORT_ORDER:
      return {
        ...state,
        orderBy:
          action.orderBy !== 'commissions.created_at' &&
          action.orderBy === state.orderBy &&
          state.orderDirection === 'asc'
            ? 'commissions.created_at'
            : action.orderBy,
        orderDirection:
          state.orderBy === action.orderBy && state.orderDirection === 'desc'
            ? 'asc'
            : 'desc'
      };
    case SHOW_TOOLTIP:
      return {
        ...state,
        activeTooltip: action.tooltip
      };
    case HIDE_TOOLTIP:
      return {
        ...state,
        activeTooltip: null
      };
    case RESET_STATE:
      return {
        ...state,
        transactionsLoading: true
      };
    default:
      return state;
  }
};
